import React, { useEffect, useMemo, useState } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import CommonTable from "../../components/CommonTable/CommonTable";
import { FaEye, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router";
import { URLS } from "../../Services/Constant";
import { deletes, get, put } from "../../Services/ApiHandler";
import { toast } from "react-toastify";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import usePermission from "../../customHook/usePermission";

const FAQ = () => {
  const [page, setPage] = useState(1);
  const [isData, setIsData] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedFAQ, setSelectedFAQ] = useState(null);
  const navigate = useNavigate();
  const permission = usePermission();

  const handleView = (row) => {
    if (!row) return;
    navigate("/faq-edit", { state: { data: row, mode: "view" } });
  };

  const handleDelete = (row) => {
    if (!row) return;
    setSelectedFAQ(row);
    setIsDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    try {
      if (selectedFAQ?.id) {
        let res = await deletes(URLS.FAQ_LIST + selectedFAQ.id + "/");
        if (res?.status === "success") {
          toast.success(res?.message || "Deleted successfully");
          fetchDataFAQ();
        } else {
          toast.error(res?.message || "Failed to delete");
        }
        setIsDeleteModalOpen(false);
        setSelectedFAQ(null);
      }
    } catch (error) {
      console.error("Error deleting FAQ:", error);
      toast.error(error?.message || "An error occurred");
    }
  };

  const handlerStatusUpdate = async (row) => {
    try {
      if (!row?.id) return;
      const res = await put(URLS.FAQ_LIST + row.id + "/", {
        status: row.status === 1 ? 0 : 1,
        question: row?.question || "",
        answer: row?.answer || "",
      });
      if (res?.status === "success") {
        toast.success(res?.message || "Status updated successfully");
        fetchDataFAQ();
      } else {
        toast.error(res?.message || "Failed to update status");
      }
    } catch (error) {
      console.error("Error updating FAQ status:", error);
      toast.error(error?.message || "An error occurred");
    }
  };

  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "sno",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <span className="sno">
              {String((row?.index || 0) + 1 + (page - 1) * 10).padStart(2, "0")}
            </span>
          );
        },
      },
      {
        Header: "FAQ",
        accessor: "question",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "",
        accessor: "adminName",
        Cell: () => {
          return null;
        },
      },
      {
        Header: "",
        accessor: "role",
        Cell: () => {
          return null;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          const getStatusClass = (status) => {
            if (status === 1) return "status-active";
            if (status === 0) return "status-inactive";
            return "";
          };

          return (
            <>
              {permission?.includes("CAN-STATUS-FAQ") && (
                <span
                  className={`status-badge ${getStatusClass(value)}`}
                  onClick={() => handlerStatusUpdate(row?.original)}
                >
                  {value === 1 ? "Active" : "Inactive"}
                </span>
              )}
            </>
          );
        },
      },
    ];

    let action = {
      Header: "Action",
      accessor: "action",
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <div style={{ flexDirection: "row", gap: "10px", display: "flex" }}>
            {permission?.includes("CAN-VIEW-FAQ") && (
              <button
                className="action-btn"
                onClick={() => handleView(row?.original)}
              >
                <FaEye />
              </button>
            )}
            {permission?.includes("CAN-DELETE-FAQ") && (
              <button
                className="action-btn"
                onClick={() => handleDelete(row?.original)}
              >
                <FaTrash color="Red" />
              </button>
            )}
          </div>
        );
      },
    };

    return [...d, action];
  }, [page]);

  const fetchDataFAQ = async () => {
    try {
      let res = await get(URLS.FAQ_LIST);
      if (res?.status === "success") {
        setIsData(res?.data || []);
      }
    } catch (error) {
      console.error("Error fetching FAQ list:", error);
    }
  };

  useEffect(() => {
    fetchDataFAQ();
  }, []);

  console.log(":isData", isData);

  return (
    <>
      <PageHeader
        title="FAQ"
        buttonText="+Add FAQ"
        buttonPath="/faq-edit"
        permissionAllowed={"CAN-ADD-FAQ"}
      />
      <CommonTable
        columns={columns}
        data={isData || []}
        showPagination={false}
      />
      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={confirmDelete}
        message="Are you sure you want to delete?"
      />
    </>
  );
};

export default FAQ;
